enum InfoType {
  INFO = 'INFO',
  ALERT = 'ALERT',
}

export default InfoType;
